module.exports = __webpack_public_path__ + "img/168089a.jpg";